import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { t } from "i18next";
import { startLogout } from "./authActions";

export const startLoadingRegionByContinentId = (continent_id) => {
  
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_REGION}`,
      `getByContinentId/${continent_id}`
    );
    const body = await resp.json();

    if (body.ok) {
      dispatch(loadingRegions(body.regions));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

export const startLoadingRegionByContinentIdLocal = (continent_id) => {
  
  return async (dispatch, getState) => {

    const state = getState();
    const { listFullRegions } = state.locationCountry;

    let regions = []; 
    listFullRegions.forEach((region) => {
      if(region.continent_id === continent_id) {
        regions.push(region);
      }
    })

    dispatch(loadingRegions(regions));

  };
};

export const loadingRegions = (regions) => ({
  type: types.LOCATIONCOUNTRY_START_LOADING_REGION,
  payload: regions,
});

export const selectRegion = (region) => ({
  type: types.LOCATIONCOUNTRY_SELECT_REGION,
  payload: region,
});

export const cleanRegion = () => ({
  type: types.LOCATIONCOUNTRY_CLEAN_REGION,
});

export const startLoadingRegions = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_REGION}`, `get`);
    const body = await resp.json();

    if (body.ok) {
      dispatch(loadingRegionsAll(body.regions));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingRegionsAll = (regions) => ({
  type: types.LOCATIONCOUNTRY_START_LOADING_REGION_ALL,
  payload: regions,
});